import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.data.ClientContainerManager.';
  public static readonly clientIsNull = `${Id.prefix}clientIsNull`;
  public static readonly clientSaved = `${Id.prefix}clientSaved`;
  public static readonly newContact = `${Id.prefix}newContact`;
}

export class LangClientContainerManager {
  private constructor() {}
  public static clientIsNull(): string {
    return interpolate(Id.clientIsNull);
  }
  public static clientSaved(params: { title: string }): string {
    return interpolate(Id.clientSaved, params);
  }
  public static newContact(): string {
    return interpolate(Id.newContact);
  }
}

export class ClientContainerManagerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.clientIsNull, "{{glossary 'client'}} is null", 'Error message when client is null');
    register.add(Id.clientSaved, '{{glossary \'client\'}} Saved "{{title}}"', 'Toast message when client is saved');
    register.add(Id.newContact, "New {{glossary 'contact'}}", 'Title for new contact');
  }
}
